export default "__VITE_ASSET__BLI3LWWC__"